// assets/product-tabs.js
(function () {
  function initProductTabs(scope = document) {
    const roots = scope.querySelectorAll('[data-pd-tabs-root]');

    roots.forEach((root) => {
      const tabs = root.querySelectorAll('.pd-tabs__btn');
      const panels = root.querySelectorAll('.pd-tabs__panel');

      if (!tabs.length || !panels.length) return;

      function activate(panelId) {
        tabs.forEach((btn) => {
          const isActive = btn.getAttribute('aria-controls') === panelId;
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.id === panelId);
        });
      }

      tabs.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const panelId = btn.getAttribute('aria-controls');
          if (!panelId) return;
          activate(panelId);
        });
      });
    });
  }

  // First load
  document.addEventListener('DOMContentLoaded', () => initProductTabs(document));

  // Horizon / Shopify dynamic loads
  document.addEventListener('shopify:section:load', (e) => initProductTabs(e.target));
})();